import React, {Component} from 'react'
import {Card, CardBody, CardTitle} from 'reactstrap';
import StdTable from '../StdTable'
import { Trans } from "react-i18next";
import {Link} from 'react-router-dom'
import Pagination from '../Pagination'

class CreditsLog extends Component{
  
  componentDidMount(){
	  this.props.getCreditsLogs()
  }

  render(){
	  const {credits_logs, current_user, getCreditsLogs} = this.props

	  const addDescription = (cl) => {
      
	    if(cl.amount > 0){
        if(cl.product != null && cl.company != null)
		      var description = <Trans values={{product: cl.product, company: cl.company.name }}>credits_logs.description_refund_row</Trans>  
        else
          var description = <Trans>credits_logs.charge</Trans>
      }
		  else if(cl.product != null && cl.company != null)
		    var description = <Trans values={{product: cl.product, company: cl.company.name }}>credits_logs.description_row</Trans>
		  
		  
		  return {...cl, ...{description: description}}	    
		}

		if(credits_logs != null && credits_logs.logs  != null){
		  return (	    
		          <Card>
		            <CardBody>
			            <CardTitle><Trans>credits_logs.title</Trans></CardTitle>

			            <div><Trans count={current_user.total_credits}>credits_logs.current_balance_message</Trans></div>
			            <Link to="/api/credits_logs.xlsx" target="_blank" className="btn btn-primary" download>
			              <i className="fas fa-file-pdf"></i> <Trans>credits_logs.actions.download_xls</Trans>
			            </Link>

			            
			            <Pagination total_pages={credits_logs.total_pages} current_page={credits_logs.current_page}  page_action={(params) => getCreditsLogs(params)} >
			              <StdTable collection={ credits_logs.logs.map(addDescription) } fields={[{name: 'created_at', type: 'date'}, {name: 'amount', type: 'number'}, 'description']} trans_prefix="credits_logs" collection_key="id" />
			            </Pagination>
		            </CardBody>
		          </Card>
		  )}
	  else
	    return null
  }
}
export default CreditsLog
